import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hockey-left',
  templateUrl: './hockey-left.component.html',
  styleUrls: ['./hockey-left.component.scss']
})
export class HockeyLeftComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
